import gql from 'graphql-tag';
import { short } from '@shared/api/fragments/user';

export const activityFeedItem = gql`
  fragment ActivityFeedItem on ActivityFeedItem {
    id
    channelId
    user {
      ...ShortUser
    }
    eventType
    createdAt
    card {
      id
      fields
    }
    count
  }

  ${short}
`;
